export const PREPARE_COMMERCE_SERVICE_NODE_TYPE = "prepare_commerce_service";

export const PREPARE_COMMERCE_SERVICE_OUTPUTS = Object.freeze([
  { id: "prepared", label: "Prepared" },
  { id: "processing_failed", label: "Processing failed" },
]);

const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const createPrepareCommerceServiceConfig = () => ({
  schemaVersion: 2,
  commerceOrderPolicyProfileId: null,
});

export const normalizePrepareCommerceServiceConfig = config => {
  const schemaVersion = Number(config?.schemaVersion);
  if (schemaVersion === 1) return { schemaVersion: 1 };
  return {
    schemaVersion: 2,
    commerceOrderPolicyProfileId:
      String(config?.commerceOrderPolicyProfileId || "").trim() || null,
  };
};

export const validatePrepareCommerceServiceConfig = (config, builderState = {}) => {
  const schemaVersion = Number(config?.schemaVersion);
  if (schemaVersion !== 1 && schemaVersion !== 2) {
    return {
      isValid: false,
      reason: "schema_version_invalid",
      message: "Prepare Commerce Service configuration uses an unsupported schema version.",
    };
  }

  if (schemaVersion === 1) {
    return {
      isValid: true,
      reason: "",
      message: "",
      normalized: { schemaVersion: 1 },
    };
  }

  const profileId = String(config?.commerceOrderPolicyProfileId || "").trim();
  if (profileId && !GUID_PATTERN.test(profileId)) {
    return {
      isValid: false,
      reason: "profile_id_invalid",
      message: "Select a valid Order Policy Profile.",
    };
  }
  if (profileId && builderState?.commerceOrderPolicyProfileStatus === "inactive") {
    return {
      isValid: false,
      reason: "profile_inactive",
      message: "The selected Order Policy Profile is inactive. Choose an active policy or use the business default.",
    };
  }
  if (profileId && builderState?.commerceOrderPolicyProfileStatus === "missing") {
    return {
      isValid: false,
      reason: "profile_missing",
      message: "The selected Order Policy Profile is unavailable. Choose another policy or use the business default.",
    };
  }
  return {
    isValid: true,
    reason: "",
    message: "",
    normalized: {
      schemaVersion: 2,
      commerceOrderPolicyProfileId: profileId || null,
    },
  };
};
